import { useState } from 'react';
import users from '../data/users.json';
import '../css/LoginForm.css';

function LoginForm({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('Both fields are required');
      return;
    }
    const match = users.find(
      (u) => u.username === username && u.password === password
    );
    if (match) {
      onLogin(username);
      setError('');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="login-page">
      <div className="login-brand">
        <div className="brand-icon">
          <i className="fa fa-train"></i>
        </div>
        <h1>RailView</h1>
        <p className="brand-subtitle">Live Monitoring System</p>
      </div>

      <div className="login-card">
        <h2 className="login-title">Sign In</h2>
        <form onSubmit={handleSubmit} className="login-form-inner">
          <div className="input-group-custom">
            <span className="input-icon"><i className="fa fa-user"></i></span>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>
          <div className="input-group-custom">
            <span className="input-icon"><i className="fa fa-lock"></i></span>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="login-btn">Sign In</button>
        </form>
      </div>

      <p className="login-footer">RailView &copy; {new Date().getFullYear()}</p>
    </div>
  );
}

export default LoginForm;
